<template>
  <v-btn v-on="$listeners" v-bind="$attrs" depressed small>
    <v-icon :color="color" class="mr-2" v-if="icon">
      {{ icon }}
    </v-icon>
    <span class="text-none">
      <slot />
    </span>
  </v-btn>
</template>

<script>
  export default {
    props: {
      icon: String,
      color: {
        type: String,
        default: 'primary',
      },
    },
  }
</script>